export default __webpack_public_path__ + "static/media/logo-cut.1da78e2d.png";